export type BylawKind = "p" | "d";

// "p" for policy bylaws (P-suffix, e.g. `123P2024` — amend a statutory
// plan); "d" for land-use redesignation bylaws (the default zoning
// bylaw shape).
export function bylawKind(b: string): BylawKind {
  return /P\d{4}$/i.test(b) ? "p" : "d";
}

export function bylawTooltip(b: string, kind: BylawKind): string {
  return kind === "p"
    ? `Bylaw ${b} — a policy bylaw amending a statutory plan (Municipal Development Plan, area redevelopment plan, etc.).`
    : `Bylaw ${b} — a land-use redesignation bylaw (changes the zoning district).`;
}
